import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ExhibitorsDirectoryModule } from './app/exhibitors-directory.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

declare global {
  interface Window {
    exhibitorsDirectoryRef: NgModuleRef<ExhibitorsDirectoryModule>;
    Calendly: { initPopupWidget: Function };
  }
}

platformBrowserDynamic().bootstrapModule(ExhibitorsDirectoryModule).then(ref => {
  if (!environment.production) {
    // Ensure Angular destroys itself on hot reloads.
    if (window['exhibitorsDirectoryRef']) {
      window['exhibitorsDirectoryRef'].destroy();
    }
    window['exhibitorsDirectoryRef'] = ref;
  }
}).catch(err => console.error(err));
